import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";

import airbnbLogo from "../../Assets/Airbnb_Logo_Bélo.png";
import expediaLogo from "../../Assets/expedia.png";
import bookingLogo from "../../Assets/booking-com.png";
import tripadvisorLogo from "../../Assets/Tripadvisor-Logo.png";
import vrboLogo from "../../Assets/Vrbo-Logo.wine.png";
import googleLogo from "../../Assets/Google.png";

import bgImage from "../../Assets/Artboard.png";
import servicesBg from "../../Assets/LWU/banner_services.png";

import maximizeIcon from "../../Assets/return.png";
import reputationIcon from "../../Assets/reputation.png";
import managementIcon from "../../Assets/management.png";
import RoadMap from "../../Components/RoadMap";
import ListwithusForm from "../../Components/ListwithusForm";
import LocationSlider from "./LocationSlider";
import CardsSlider from "./CardsSlider";
import DynamicSeoPage from "../DynamicSeoPage";

const ListWithUs = () => {
  const [section, setSection] = useState({});

  const fetchSection = async () => {
    try {
      const response = await axios.get(
        `https://365luxuryhomes.com/api/sections/property_owners`
      );

      if (response.data) {
        setSection(response.data);
      }
    } catch (error) {
      console.error("Error fetching section:", error);
    }
  };

  useEffect(() => {
    fetchSection();
  }, []);

  return (
    <>
      <DynamicSeoPage
        page="list-with-us"
        defalut={"365 Luxury Homes - Find your Vacation Holiday in Dubai"}
      />
      <div
        id="my_modal_3"
        className="p-4 fixed top-0 leading-0 w-full h-full z-[99999]  px-2 flex items-center justify-center backdrop-blur-xs bg-[#2e2e2e91] hidden"
      >
        <div
          className={`md:w-[50rem] max-w-[70rem] max-h-[90vh] overflow-y-auto rounded-3xl bg-white bg-cover bg-center relative overflow-hidden`}
        >
          {/* if there is a button in form, it will close the modal */}
          <button
            onClick={() => {
              const modal = document.getElementById("my_modal_3");
              modal?.classList.toggle("hidden");
              document.body.style.overflow = "auto";
            }}
            className="btn btn-sm btn-circle btn-ghost md:absolute md:top-2 md:right-2 fixed z-50 right-6 top-12 text-red-500 text-xl"
          >
            ✕
          </button>
          <div className="relative z-10">
            <ListwithusForm type="popup" />
          </div>
        </div>
      </div>

      <section className="pb-14">
        <section
          className="listwithus_banner pt-20 pb-20 relative"
          id="banner"
          style={{
            backgroundImage: `url(${section?.imageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 z-10 bg-gradient-to-r from-black/70 to-transparent" />
          <div className="container !px-10 flex flex-col items-start justify-end h-full relative z-20">
            <h1
              className="text-white text-[1.5rem] md:text-[2rem] lg:text-[2rem] leading-[2.3rem]"
              data-aos="fade-up"
            >
              Partner with Dubai's
              <br /> Elite Holiday Home Management Experts
            </h1>
            <p
              className="text-white text-lg mt-4"
              data-aos="fade-up"
              data-aos-delay="50"
            >
              Unlock Your Property's True Potential. Maximize Your Returns and{" "}
              <br /> Experience Unmatched Peace of Mind with 365 Luxury Homes.
            </p>
            <a
              onClick={() => {
                const modal = document.getElementById("my_modal_3");
                modal?.classList.toggle("hidden");
                document.body.style.overflow = "hidden";
              }}
              href="##"
              className="bg-[#fff] text-[#6c675b] flex items-center gap-2 px-6 h-[50px] rounded-md  focus:ring-2 focus:ring-gray-400 mt-4 cursor-pointer hover:text-[#6c675b] active:text-[#6c675b] hover:no-underline"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              List with us
            </a>
          </div>
        </section>
        <div className="container !px-10 flex flex-col items-center justify-center h-full">
          <div className="mt-20">
            <h3
              className="text-[#74716d] font-thin text-center lg:text-2xl md:text-2xl text-xl"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <span className="lg:text-4xl text-2xl font-medium">
                Maximizing Your Visibility
              </span>
              <br />
              <span className="lg:text-3xl text-xl">
                Across Premier Booking Platforms
              </span>
            </h3>
            <div
              className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 mt-8"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="px-10 flex items-center justify-center py-3 rounded-md shadow-lg border">
                <img src={airbnbLogo} alt="" className="w-36" />
              </div>
              <div className="px-10 flex items-center justify-center py-3 rounded-md shadow-lg border">
                <img src={bookingLogo} alt="" className="w-36" />
              </div>
              <div className="px-10 flex items-center justify-center py-3 rounded-md shadow-lg border">
                <img src={expediaLogo} alt="" className="w-36" />
              </div>
              <div className="px-10 flex items-center justify-center py-3 rounded-md shadow-lg border">
                <img src={tripadvisorLogo} alt="" className="w-36" />
              </div>
              <div className="px-10 flex items-center justify-center py-3 rounded-md shadow-lg border">
                <img src={vrboLogo} alt="" className="w-36" />
              </div>
              <div className="px-10 flex items-center justify-center py-3 rounded-md shadow-lg border">
                <img src={googleLogo} alt="" className="w-36" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="py-20 relative"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex items-end -rotate-90 h-8 absolute lg:-left-24 md:-left-24 -left-[6rem] top-1/2 translate-y-1/2 w-46">
          <span className="text-xl text-white">RETURNS</span>
          <div className="w-36 h-[2px] bg-white"></div>
        </div>
        <div className="container !px-10">
          <h3
            className="text-center lg:text-2xl md:text-2xl text-xl text-white"
            data-aos="fade-up"
            data-aos-offset="200"
            data-aos-delay="150"
          >
            <span className="lg:text-4xl md:text-3xl text-2xl font-medium">
              The 365 Advantage:
            </span>
            <br />
            <span className="lg:text-[1.2rem] font-medium">
              A Symphony of Service and Returns
            </span>
          </h3>
          <div
            data-aos="fade-up"
            data-aos-offset="200"
            data-aos-delay="50"
            className="flex lg:flex-nowrap md:flex-nowrap flex-wrap items-start lg:gap-4 md:gap-4 gap-10 mt-10"
          >
            <div className="flex flex-col items-center gap-2">
              <img src={maximizeIcon} alt="" className="w-10" />
              <h4 className="text-center text-white font-medium">
                Maximized Returns
              </h4>
              <p className="text-white text-[16px] text-center">
                Our expert pricing strategies, high occupancy rates, and access
                to a premium clientele base ensure your property is positioned
                for optimal returns and maximum profitability.
              </p>
            </div>
            <div className="min-w-[2px] h-10 bg-white lg:block md:block hidden"></div>
            <div className="flex flex-col items-center gap-2">
              <img src={managementIcon} alt="" className="w-10" />
              <h4 className="text-center text-white font-medium">
                End-to-End Management
              </h4>
              <p className="text-white text-[16px] text-center">
                From targeted marketing and guest relations to meticulous
                maintenance via our 365 Maintenance partnership, we handle every
                detail for a completely hassle-free ownership experience.
              </p>
            </div>
            <div className="min-w-[2px] h-10 bg-white lg:block md:block hidden"></div>
            <div className="flex flex-col items-center gap-2">
              <img src={reputationIcon} alt="" className="w-10" />
              <h4 className="text-center text-white font-medium">
                A Reputation of Excellence
              </h4>
              <p className="text-white text-[16px]  text-center">
                As a pillar of the 365 Group, your property benefits from an
                elite status in Dubai's luxury rental market, ensuring it stands
                out and attracts discerning guests.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#94928f] py-20 relative">
        <div className="flex items-end -rotate-90 h-8 absolute lg:-left-36 md:-left-[9rem] -left-[9rem] top-1/2 translate-y-1/2 w-46 z-20">
          <span className="text-xl text-white">EARNING JOURNEY</span>
          <div className="w-36 h-[2px] bg-white"></div>
        </div>
        <div className="container">
          <h3
            className="text-center lg:text-2xl md:text-2xl text-xl text-white mb-14"
            data-aos="fade-up"
          >
            <span className="lg:text-4xl md:text-3xl text-2xl font-medium">
              Your Journey to Effortless Earnings
            </span>
            <br />
            <span className="lg:text-3xl text-xl">in 4 Simple Steps</span>
          </h3>
          <RoadMap />
        </div>
      </section>

      <section
        className="lg:py-20 md:py-16 py-10 relative"
        style={{
          backgroundImage: `url(${servicesBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex items-end -rotate-90 h-8 absolute lg:-left-24 md:-left-24 -left-[6.4rem] top-1/2 translate-y-1/2 w-46 z-20">
          <span className="text-xl text-white">SERVICES</span>
          <div className="w-36 h-[2px] bg-white"></div>
        </div>
        <div
          className="container !px-10"
          data-aos="fade-up"
          data-aos-offset="200"
          data-aos-delay="50"
        >
          <div className="flex lg:flex-row  flex-col gap-8">
            <div className="lg:w-[20%] md:w-[60%] md:mx-auto">
              <h3
                className="mt-14 text-3xl text-white lg:text-left md:text-center"
                data-aos="fade-up"
              >
                A Holistic Approach to Luxury Property Management
              </h3>
            </div>
            <div className="lg:w-[70%] md:w-full" data-aos="fade-up">
              <CardsSlider />
            </div>
          </div>
        </div>
      </section>

      {/* <section className=" relative">
        <LocationSlider />
      </section> */}

      {/* <section className="bg-[#fdfcf5] py-10" id="form">
        <div className="container">
          <div className="flex md:justify-between justify-center items-center mt-4 w-[80%] mx-auto shadow-lg rounded-xl overflow-hidden bg-[#ecebe9] md:p-0 p-5">
            <img
              src={formImage}
              alt=""
              className="lg:w-[40%] md:w-[40%] md:block hidden h-full md:h-[34rem] object-cover"
            />
            <div className="lg:w-[60%] md:w-[60%] lg:px-20 md:px-10 py-10">
              <h3 className="lg:text-[5.5rem] md:text-[4.5rem] text-[4rem] text-[#94928f] font-medium ">
                Discover
              </h3>
              <p className="text-[#94928f] lg:text-[1.1rem] md:text-[1rem] font-medium mt-5 ml-[3px]">
                Your Property's Earning Potential Today
              </p>
              <form onSubmit={handleSubmit} className="space-y-4 mt-10">
                {["name", "email"].map((field, idx) => (
                  <div key={idx}>
                    <input
                      type={field === "email" ? "email" : "text"}
                      name={field}
                      value={formData[field]}
                      required
                      placeholder={`Your ${field}`}
                      onChange={handleChange}
                      className="w-full bg-transparent text-[#74716d] border-[1px] !border-b-[#aca9a5] text-[16px] p-2 h-[40px] focus:outline-none focus:ring-0 focus:border-[#aca9a5] text-lg"
                    />
                  </div>
                ))}
                <div className="flex">
                  <div className="w-60">
                    <CustomDropdown
                      allCountryCodes={allCountryCodes}
                      formData={formData}
                      setFormData={setFormData}
                    />
                  </div>
                  <input
                    type="number"
                    id="phone"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    required
                    className="w-full border-b border-[#aca9a5] bg-transparent focus:outline-none focus:ring-0  placeholder-[#aca9a5] text-[#74716d] h-[38px] appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
         [&::-webkit-inner-spin-button]:m-0 text-lg"
                  />
                </div>
                {phoneError && (
                  <p className="text-red-500 text-xs mt-1">{phoneError}</p>
                )}
                <ReCAPTCHA
                  sitekey="6LfeklorAAAAAPUFX08mcywgvxkSSOv-dczoUTrv"
                  onChange={handleCaptcha}
                />

                <button className="btn w-full text-[#74716d] shadow-lg text-lg font-normal">
                  Request for Consultation
                </button>
              </form>
            </div>
          </div>
        </div>
      </section> */}
      <section className="py-10">
        <div className="container">
          <ListwithusForm />
        </div>
      </section>
    </>
  );
};

export default ListWithUs;
